import type { DashboardTimeRange } from './DashboardTimeRangeContext';

import { cn } from '@/components/ui';

const TIME_RANGE_OPTIONS: { value: DashboardTimeRange; label: string }[] = [
  { value: '1h', label: '1h' },
  { value: '6h', label: '6h' },
  { value: '24h', label: '24h' },
  { value: '7d', label: '7d' },
  { value: '30d', label: '30d' },
];

export interface TimeRangeSelectorProps {
  value: DashboardTimeRange;
  onChange: (value: DashboardTimeRange) => void;
  className?: string;
}

export function TimeRangeSelector({ value, onChange, className }: TimeRangeSelectorProps) {
  return (
    <div
      className={cn(
        'inline-flex rounded-lg border border-gray-200 dark:border-white/[0.08]',
        className
      )}
    >
      {TIME_RANGE_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={cn(
            'px-2.5 py-1 text-xs font-medium transition-colors first:rounded-l-[7px] last:rounded-r-[7px]',
            value === option.value
              ? 'bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300'
              : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 dark:text-zinc-400 dark:hover:bg-white/[0.04] dark:hover:text-zinc-300'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
